import React, { useMemo, useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  setMessageTab,
  filterByTag,
  unfilterByTag,
  filterThreads,
  setSubMessageTab,
  fetchThreadsUnread,
  fetchThreads,
  getTaskBadge,
} from "../../actions/ThreadAction";

const MessageNav = ({ onTabSelect }) => {
  const {
    tab,
    circleLabelId,
    circleLabels,
    tagsSelectShown,
    read,
    taskCount
  } = useSelector(mySelector, shallowEqual);

  const dispatch = useDispatch();

  const tabs = {
    ALL: "ALL",
    UNREAD: "UNREAD",
    TASKS: "TASKS",
    ALERTS: "ALERTS",
  };

  const activeClass = "hc-nav-link active";
  const inactiveClass = "hc-nav-link";

  useEffect(() => {
    dispatch(getTaskBadge());
  }, []);

  const handleClick = (newTab) => {
    if (newTab === tab) return;
    if (newTab === "ALL") {
      // filterThreads({ attention: true })(dispatch);
      // dispatch(fetchThreadsUnread(0, "all"));
      dispatch(fetchThreads("", false, 0, "", "", read));
    }
    dispatch(setMessageTab(newTab));

    onTabSelect(newTab);
  };

  const handleChange = (circleLabelId) => {
    dispatch(filterByTag(circleLabelId));
  };

  const handleCancel = () => {
    dispatch(unfilterByTag());
  };

  const handleSubMessageTab = (tab) => {
    dispatch(setSubMessageTab(tab));
  };

  if (tagsSelectShown) {
    return (
      <div className="message-nav d-flex flex-fill">
        <div className="input-group rounded">
          <select
            value={circleLabelId}
            className="custom-select text-primary"
            id="inputGroupSelect01"
            onChange={(e) => handleChange(e.target.value)}
          >
            <option value="" selected>
              Choose tag...
            </option>
            {circleLabels.map((label) => (
              <option value={label.objectId}># {label.name}</option>
            ))}
          </select>
          <div className="input-group-append">
            <button onClick={(e) => handleCancel()} className="btn btn-danger">
              <i className="fas fa-fw fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="message-nav">
      <ul className="nav nav-pills nav-justified hc-nav-pills">
        {/* <li className="nav-item">
          <a
            onClick={() => handleClick(tabs.ALL)}
            className={tab === tabs.ALL ? activeClass : inactiveClass}
            href="#"
          >
            All
          </a>
        </li> */}
        <li className="nav-item">
          <a onClick={() => handleClick(tabs.ALL)} className={tab === tabs.ALL ? activeClass : inactiveClass} href="#">
            Messages
          </a>
        </li>
        {/* <li className="nav-item">
          <a
            onClick={() => handleClick(tabs.TASKS)}
            className={tab === tabs.TASKS ? activeClass : inactiveClass}
            href="#"
          >
            Tasks
          </a>
        </li> */}
        <li className="nav-item">
          <a
            onClick={() => handleClick(tabs.TASKS)}
            className={tab === tabs.TASKS ? activeClass : inactiveClass}
            href="#"
          >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span>Tasks</span>&nbsp;
              <span 
                className="badge badge-pill custom-badge"
                style={{
                  backgroundColor: `${tab === tabs.TASKS ? "white" : "#2194f3"}`,
                  color: `${tab === tabs.TASKS ? "#2194f3" : "white"}`,
                }}
              >
                {taskCount}
              </span>
            </div>
          </a>
        </li>
      </ul>
    </div>
  );
};

const mySelector = (state) => ({
  tab: state.thread.activeMessageTab,
  circleLabelId: state.thread.circleLabelId,
  circleLabels: state.dashboard.circleLabels,
  tagsSelectShown: state.thread.tagsSelectShown,
  read: state.thread.read,
  taskCount: state.priority.taskCount,
});

export default MessageNav;
